import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  inputs: ['showAppLevelAlert']
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./src/app/app.component.ts